import { render, staticRenderFns } from "./UploadsTable.vue?vue&type=template&id=cfa7f2d8&scoped=true"
import script from "./UploadsTable.vue?vue&type=script&lang=ts"
export * from "./UploadsTable.vue?vue&type=script&lang=ts"
import style0 from "./UploadsTable.vue?vue&type=style&index=0&id=cfa7f2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa7f2d8",
  null
  
)

export default component.exports